"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _componentAnalytics = require("../Components/ComponentAnalytics/componentAnalytics");

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Picture = function Picture(_ref) {
  var webp = _ref.webp,
      png = _ref.png,
      alt = _ref.alt;
  (0, _react.useEffect)(function () {
    (0, _componentAnalytics.trackMe)("Picture");
  }, []);
  return /*#__PURE__*/_react.default.createElement(PictureContainer, null, webp && /*#__PURE__*/_react.default.createElement("source", {
    srcSet: webp,
    type: "image/webp"
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: png,
    alt: alt
  }));
};

var PictureContainer = _styledComponents.default.picture.withConfig({
  displayName: "PictureContainer",
  componentId: "sc-pusc0b-0"
})(["img{width:100%;height:auto;}"]);

Picture.propTypes = {
  webp: _propTypes.default.string,
  png: _propTypes.default.string.isRequired,
  alt: _propTypes.default.string.isRequired
};
var _default = Picture;
exports.default = _default;